import { useState } from "react";
import { Stack, IconButton } from "@altimateai/lego";
import { AutoPlusIcon, InfoIcon } from "@assets/icons";
import { CommonIntegrationInstance } from "./mcpSlice";
import ConnectionsList from "./ConnectionsList";
import ConnectionsForm from "./ConnectionsForm";
import { Card, CardContent, CardHeader } from "@altimateai/lego";

interface ConnectionsProps {
  integration: CommonIntegrationInstance;
  onConnectionCreated?: () => void;
  onSelect?: (connectionId: string, integrationId: string) => void;
  selectedConnectionId?: string;
}

const CONNECTIONS_HELP_TEXT =
  "Connections are configurations like PAT tokens or api urls required to execute the tools. You can either add the connections here to store securely in our db or add in IDEs as needed.";

const Connections = ({
  integration,
  onConnectionCreated,
  onSelect,
  selectedConnectionId,
}: ConnectionsProps) => {
  const [isCreating, setIsCreating] = useState(false);
  if (!integration.config || integration.config.length === 0) {
    return null;
  }

  return (
    <Card className="!al-p-0 !al-py-2">
      <CardHeader className="!al-p-4 !al-pt-0">
        <Stack direction="row" justify="between" align="center">
          <Stack direction="row" align="center" className="al-gap-2">
            <h3 className="al-text-sm al-font-medium">Connections</h3>
            <abbr title={CONNECTIONS_HELP_TEXT}>
              <InfoIcon className="al-w-4 al-h-4 al-text-gray-500" />
            </abbr>
          </Stack>
          {!isCreating && (
            <IconButton
              variant="outline"
              className="al-p-2"
              aria-label="Add Connection"
              onClick={e => {
                e.stopPropagation();
                setIsCreating(true);
              }}
              title="Add Connection"
            >
              <AutoPlusIcon className="al-w-4 al-h-4" />
            </IconButton>
          )}
        </Stack>
      </CardHeader>
      <CardContent className="!al-p-4 !al-pt-0 !al-pb-0">
        {/* List existing connections */}
        <ConnectionsList
          integration={integration}
          onSelect={onSelect}
          selectedConnectionId={selectedConnectionId}
        />
        {/* Form to create new connection */}
        {isCreating && (
          <ConnectionsForm
            integration={integration}
            onSuccess={() => {
              setIsCreating(false);
              onConnectionCreated?.();
            }}
            onCancel={() => setIsCreating(false)}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default Connections;
